// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arrow-container {
  height: 30px;
  width: 30px;
  border-radius: 15px;
  padding: 3px 0px 0px 2px;
  border: 1px solid #8B0096;
}
.arrow-container:hover {
  border: 1px solid #29bb73;
}

.title-text {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}

.subtitle-text {
  color: #6B556C;
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 18px;
}

.notes-area {
  height: 160px;
}

.request-wrapper {
  padding-top: 16px;
  background-color: white;
  margin-bottom: 64px;
  border-top: 1px solid #EDEDED;
  border-bottom: 1px solid #EDEDED;
}
.request-wrapper .header {
  margin-top: 15px;
  padding-bottom: 15px;
}
.request-wrapper .title-text {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .subtitle-text {
  color: #6B556C;
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .section-wrapper {
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EDEDED;
}
@media (min-width: 768px) {
  .request-wrapper .section-wrapper {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
@media (min-width: 1024px) {
  .request-wrapper .section-wrapper {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.request-wrapper .section-wrapper .title-wr {
  margin-top: 8px;
  margin-bottom: 10px;
}
.request-wrapper .section-wrapper .title-wr .title-text {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .section-wrapper .form-check-label {
  opacity: 0.8;
  color: #382738;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.46px;
  line-height: 18px;
}
.request-wrapper .section-wrapper .details-wrapper {
  margin-top: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #EDEDED;
  border-top: 1px solid #EDEDED;
  background-color: #FCFCFC;
}
.request-wrapper .section-wrapper .details-wrapper .title {
  color: #3E0D42;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.39px;
  line-height: 15px;
}
.request-wrapper .section-wrapper .details-wrapper .subtitle {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.69px;
  line-height: 22px;
}
.request-wrapper .section-wrapper .details-wrapper .action-text {
  margin-left: 12px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.75px;
  line-height: 14px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper {
  border: 1px solid lightgray;
  margin-bottom: 16px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper .item {
  margin: 12px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper .item-name {
  color: #3E0D42;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 16px;
}
.request-wrapper .section-wrapper .details-wrapper .item-wrapper .item-info {
  opacity: 0.8;
  color: #382738;
  font-size: 11px;
  letter-spacing: 0.55px;
  line-height: 18px;
}
.request-wrapper .request-footer {
  margin-top: 22px;
}
.request-wrapper .request-footer .btn {
  height: 30px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
}
.request-wrapper .request-footer .btn-outline-dark {
  color: #382738;
  border: 1px solid #EBE9EB;
  background-color: #FFFFFF;
}
.request-wrapper .additional-notes {
  color: #3E0D42;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.39px;
  line-height: 15px;
  margin-bottom: 5px;
}
.request-wrapper .notes-area {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  background-color: #FCFCFC;
  width: 100%;
  height: 160px;
}
.request-wrapper .accordion-wrapper .header-row {
  padding: 10px 0;
}
.request-wrapper .accordion-wrapper .broadcaster-name {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.request-wrapper .accordion-wrapper .request-date {
  color: #382738;
  font-size: 11px;
  letter-spacing: 0.55px;
  line-height: 18px;
}
.request-wrapper .accordion-wrapper .request-status {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.69px;
  line-height: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/fixture-details/league-fixture-detail/league-fixture-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;AACF;AACE;EACE,yBAAA;AACJ;;AAGA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AAAF;AAEE;EACE,gBAAA;EACA,oBAAA;AAAJ;AAIE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AAHJ;AAME;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;AAJJ;AAMI;EALF;IAMI,iBAAA;IACA,oBAAA;EAHJ;AACF;AAKI;EAVF;IAWI,iBAAA;IACA,oBAAA;EAFJ;AACF;AAKI;EACE,eAAA;EACA,mBAAA;AAHN;AAKM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAHR;AAOI;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AALN;AAQI;EACE,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,6BAAA;EACA,yBAAA;AANN;AAQM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AANR;AASM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAPR;AAUM;EACE,iBAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AATR;AAYM;EACE,2BAAA;EACA,mBAAA;AAVR;AAYQ;EACE,YAAA;AAVV;AAaQ;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAXV;AAcQ;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAZV;AAkBE;EACE,gBAAA;AAhBJ;AAkBI;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAhBN;AAmBI;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;AAjBN;AAqBE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;AApBJ;AAwBI;EACE,eAAA;AAtBN;AAyBI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAvBN;AA0BI;EACE,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAxBN;AA2BI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAzBN","sourcesContent":[".arrow-container {\n  height: 30px;\n  width: 30px;\n  border-radius: 15px;\n  padding: 3px 0px 0px 2px;\n  border: 1px solid #8B0096;\n\n  &:hover {\n    border: 1px solid #29bb73;\n  }\n}\n\n.title-text {\n  color: #3E0D42;\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n}\n\n.subtitle-text {\n  color: #6B556C;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n}\n\n.notes-area {\n  height: 160px;\n}\n\n.request-wrapper {\n  padding-top: 16px;\n  background-color: white;\n  margin-bottom: 64px;\n  border-top: 1px solid #EDEDED;\n  border-bottom: 1px solid #EDEDED;\n\n  .header {\n    margin-top: 15px;\n    padding-bottom: 15px;\n    // border-bottom: 1px solid #EDEDED;\n  }\n\n  .title-text {\n    color: #3E0D42;\n    font-size: 14px;\n    font-weight: bold;\n    letter-spacing: 0.5px;\n    line-height: 18px;\n  }\n\n  .subtitle-text {\n    color: #6B556C;\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    line-height: 18px;\n  }\n\n  .section-wrapper {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #EDEDED;\n\n    @media (min-width: 768px) {\n      padding-top: 30px;\n      padding-bottom: 30px;\n    }\n\n    @media (min-width: 1024px) {\n      padding-top: 40px;\n      padding-bottom: 40px;\n    }\n\n\n    .title-wr {\n      margin-top: 8px;\n      margin-bottom: 10px;\n\n      .title-text {\n        color: #3E0D42;\n        font-size: 14px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        line-height: 18px;\n      }\n    }\n\n    .form-check-label {\n      opacity: 0.8;\n      color: #382738;\n      font-size: 13px;\n      font-weight: bold;\n      letter-spacing: 0.46px;\n      line-height: 18px;\n    }\n\n    .details-wrapper {\n      margin-top: 16px;\n      padding: 20px 0;\n      border-bottom: 1px solid #EDEDED;\n      border-top: 1px solid #EDEDED;\n      background-color: #FCFCFC;\n\n      .title {\n        color: #3E0D42;\n        font-size: 11px;\n        font-weight: bold;\n        letter-spacing: 0.39px;\n        line-height: 15px;\n      }\n\n      .subtitle {\n        color: #6B556C;\n        font-size: 11px;\n        font-weight: bold;\n        letter-spacing: 0.69px;\n        line-height: 22px;\n      }\n\n      .action-text {\n        margin-left: 12px;\n        // color: #29BB73;\n        font-size: 12px;\n        font-weight: bold;\n        letter-spacing: 0.75px;\n        line-height: 14px;\n      }\n\n      .item-wrapper {\n        border: 1px solid lightgray;\n        margin-bottom: 16px;\n\n        .item {\n          margin: 12px;\n        }\n\n        .item-name {\n          color: #3E0D42;\n          font-size: 13px;\n          font-weight: bold;\n          letter-spacing: 0.5px;\n          line-height: 16px;\n        }\n\n        .item-info {\n          opacity: 0.8;\n          color: #382738;\n          font-size: 11px;\n          letter-spacing: 0.55px;\n          line-height: 18px;\n        }\n      }\n    }\n  }\n\n  .request-footer {\n    margin-top: 22px;\n\n    .btn {\n      height: 30px;\n      border-radius: 3px;\n      font-size: 12px;\n      font-weight: bold;\n    }\n\n    .btn-outline-dark {\n      color: #382738;\n      border: 1px solid #EBE9EB;\n      background-color: #FFFFFF\n    }\n  }\n\n  .additional-notes {\n    color: #3E0D42;\n    font-size: 11px;\n    font-weight: bold;\n    letter-spacing: 0.39px;\n    line-height: 15px;\n    margin-bottom: 5px;\n  }\n\n  .notes-area {\n    border: 1px solid #EBE9EB;\n    border-radius: 3px;\n    background-color: #FCFCFC;\n    width: 100%;\n    height: 160px;\n  }\n\n  .accordion-wrapper {\n    .header-row {\n      padding: 10px 0;\n    }\n\n    .broadcaster-name {\n      color: #3E0D42;\n      font-size: 14px;\n      font-weight: bold;\n      letter-spacing: 0.5px;\n      line-height: 18px;\n    }\n\n    .request-date {\n      color: #382738;\n      font-size: 11px;\n      letter-spacing: 0.55px;\n      line-height: 18px;\n    }\n\n    .request-status {\n      color: #6B556C;\n      font-size: 11px;\n      font-weight: bold;\n      letter-spacing: 0.69px;\n      line-height: 13px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
